
import { Browse } from "@/models/browse";
import { BrowseService } from "@/services";
import { Barcode, BarcodeFormat } from "@/utils/label-layout/barcode";
import { LabelLayout } from "@/utils/label-layout/label-layout";
import { Model } from "@/utils/models/model";
import Vue from "vue";
import AppColumnSelect from "@/components/models/ColumnSelect.vue";
import { ISelectItem } from "winfakt-vue-components";
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";

export default Vue.extend({
	data(){
		return {
			barcode: new Barcode(),
		};
	},
	props: {
		value: {
			type: Object as ()=>Barcode,
			required: true
		},
		model: {
			type: Object as ()=>Model,
			required: true
		},
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		}
	},
	computed: {
		browse():Browse | null{
			return BrowseService.getBrowseWithoutViewSettings(this.layout.BrowseID);
		},
		formats():ISelectItem<string>[]{
			return getEnumKeys(BarcodeFormat).map(f=>{
				return {
					text: f,
					value: getEnumValueFromKey(BarcodeFormat, f)
				};
			});
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.barcode = new Barcode(this.value.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", new Barcode(this.barcode.getJSON()));
			this.close();
		},
	},
	components: {
		AppColumnSelect
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
